import { render } from "./NavBtnTab.vue?vue&type=template&id=2f22fabc"
import script from "./NavBtnTab.vue?vue&type=script&lang=js"
export * from "./NavBtnTab.vue?vue&type=script&lang=js"

import "./NavBtnTab.vue?vue&type=style&index=0&id=2f22fabc&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__